import loadable from '@loadable/component';
import { OverlaySpinner } from '@ankr.com/ui';
import { Navigate } from 'react-router';

import { NoSSRGuard } from 'modules/common/components/NoSSRGuard';
import { NoWeb3AuthGuard } from 'modules/auth/components/NoWeb3AuthGuard';
import { Placeholder } from 'modules/common/components/Placeholder';
import { chainsRoutesConfig } from 'domains/chains/routes';
import { homeRoutesConfig } from 'domains/home/routes';
import { useAuth } from 'modules/auth/hooks/useAuth';

const SwaggerUIPage = loadable(
  async () => {
    const module = await import('./SwaggerUIPage');

    return module.SwaggerUIPage;
  },
  {
    fallback: <OverlaySpinner />,
  },
);

const homePath = homeRoutesConfig.home.generatePath();
const chainsPath = chainsRoutesConfig.chains.generatePath();

export const SwaggerUIPageContainer = () => {
  const { authToken, isLoggedIn, isLoggingIn } = useAuth();

  const hasAuthToken = Boolean(authToken);
  const shouldLogIn = hasAuthToken && !isLoggedIn;

  const loading = isLoggingIn || shouldLogIn;

  return (
    <NoSSRGuard>
      <Placeholder hasPlaceholder={loading} placeholder={<OverlaySpinner />}>
        <Placeholder
          hasPlaceholder={!isLoggedIn}
          placeholder={<Navigate to={chainsPath} />}
        >
          <NoWeb3AuthGuard fallback={<Navigate to={homePath} />}>
            <SwaggerUIPage />
          </NoWeb3AuthGuard>
        </Placeholder>
      </Placeholder>
    </NoSSRGuard>
  );
};
